// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IPFS-module__particle___DvHKr{min-height:200px;padding:0 10px}", "",{"version":3,"sources":["webpack://./src/containers/ipfs/IPFS.module.scss"],"names":[],"mappings":"AAAA,+BACE,gBAAA,CACA,cAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"particle": "IPFS-module__particle___DvHKr"
};
export default ___CSS_LOADER_EXPORT___;
